import cx from "classnames";
import React, { CSSProperties } from "react";
import { Icons } from "shared/ui/index";
import styles from "./checkbox.module.scss";

export interface ICheckbox {
  children?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;

  onChange?: (value: boolean) => void;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Checkbox = (props: ICheckbox) => {
  return (
    <label
      className={cx(styles.checkbox, props.disabled && styles.disabled, props.className)}
      style={props.style}
      id={props.htmlId}
    >
      <span className={styles.check}>
        <input
          type="checkbox"
          checked={props.checked}
          onChange={(e) => props.onChange?.(e.target.checked)}
          disabled={props.disabled}
        />
        <span className={styles.icon}>
          <Icons.CheckboxOn />
        </span>
      </span>
      {props.children && <span className={styles.text}>{props.children}</span>}
    </label>
  );
};

Checkbox.defaultProps = {};
